import React, { useEffect, useState } from "react";
import classes from "./index.module.css";
import "../assets/css/style.css";
import { Typography } from "@mui/material";
import onboard1 from "../assets/images/onboard1.png";
import onboard2 from "../assets/images/onboard2.png";
import onboard3 from "../assets/images/onboard3.png";

const items = [
  {
    name: "Track your attendance",
    description: "Simply tap on time in and time out to mark your attendance.",
    image: onboard1,
  },
  {
    name: "Manage your medium or small business",
    description: "Know your team's whereabouts and assign tasks easily.",
    image: onboard2,
  },
  {
    name: "Sales and field staff tracking",
    description: "Get reports on attendance, tasks and route mapping.",
    image: onboard3,
  },
];

function App() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setActive((a) => (a + 1) % items.length);
    }, 4000);
    return () => clearInterval(id);
  }, []);

  const current = items[active];

  return (
    <div style={{ height: "100%" }}>
      <div className="bg-auth">
        <div className="testi-contain">
          <Typography className={classes.imageCoroselHeader}>
            {current.name}
          </Typography>
          <p className={classes.imageCoroselSubtitle}>{current.description}</p>
          <img
            src={current.image}
            alt={current.name}
            className={classes.imageCoroselImage}
          />
        </div>
        <div className={classes.imageCoroselIndicators}>
          {items.map((_, i) => (
            <button
              key={i}
              type="button"
              aria-label={`carousel indicator ${i + 1}`}
              onClick={() => setActive(i)}
              className={
                i === active
                  ? classes.imageCoroselDotActive
                  : classes.imageCoroselDot
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;
